import { Fragment, useState } from "react";
import { Offcanvas } from "react-bootstrap";
import useBorrowerInfo from "../../store";
import AnalysisCard from "./analysis-card";
import { format } from "date-fns";
import { getNonPayReason, getPaidType, getPaymentMode, getPaymentPlan, getReason } from "../../helpers";
import ContentLoader from "../../../../../Components/ContentLoader";
import { IoCloseCircle } from "react-icons/io5";

export default function OnlineCaseStatus() {
  const [isOpen, setIsOpen] = useState(false);

  const analysis = useBorrowerInfo((state) => state.analysis);
  const isLoading = useBorrowerInfo((state) => state.isAnalysisLoading);
console.log(analysis);
  const toggle = () => setIsOpen((prev) => !prev);

  const getDisposition = (intention) => {
    if (!intention) return "";

    return intention.includes("refuseToPay__needMoreTime")
      ? "Promise to Pay"
      : intention.includes("yesWillPay__requestSettlement")
      ? "Settlement"
      : intention.includes("yesWillPay")
      ? "Promise To Pay"
      : intention.includes("alreadyPaid_fullPaid_thankyou")
      ? "Already Paid"
      : intention.includes("alreadyPaid")
      ? "Partial Paid"
      : intention.includes("refuseToPay")
      ? "Refuse To Pay"
      : intention;
  };

  const renderDispositionDetails = (disposition, data) => {
    switch (disposition) {
      case "Settlement":
        return [
          { label: "1st Pay Date", value: data.pay_date_1 ? format(new Date(data.pay_date_1), "dd MMM yyyy") : "" },
          { label: "2nd Pay Date", value: data.pay_date_2 ? format(new Date(data.pay_date_2), "dd MMM yyyy") : "" },
          { label: "Payment Plan", value: getPaymentPlan(data.payment_plan) },
          { label: "Submission Date", value: data.submission_date },
          { label: "IP Address", value: data.ip_address },
        ];
      case "Promise To Pay":
        return [
          { label: "PTP Amount", value: data.ptp_amount ? `Rs. ${data.ptp_amount}` : "" },
          { label: "PTP Date", value: data.ptp_date },
          { label: "Submission Date", value: data.submission_date },
          { label: "IP Address", value: data.ip_address },
        ];
      case "Already Paid":
      case "Partial Paid":
        return [
          { label: "Amount Paid", value: data.amount_paid },
          { label: "Paid Date", value: data.paid_date ? format(new Date(data.paid_date), "dd MMM yyyy") : "" },
          { label: "Submission Date", value: data.submission_date },
          { label: "IP Address", value: data.ip_address },
        ];
      case "Refuse To Pay":
        return [
          { label: "Remark", value: getReason(data.reason) },
          { label: "Submission Date", value: data.submission_date },
          { label: "IP Address", value: data.ip_address },
        ];
      default:
        return [];
    }
  };

  return (
    <>
      <AnalysisCard
        onClick={toggle}
        title="Online Case Status"
        isLoading={isLoading}
        tag={analysis?.online_tag}
        content={analysis?.online_disposition}
        icon={(props) => (
          <svg {...props} style={{ width: "20px", objectFit: "contain" }} fill="currentColor" viewBox="0 0 576 530" xmlns="http://www.w3.org/2000/svg">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M69 448.536C69 433.625 81.0883 421.536 96 421.536H315C329.912 421.536 342 433.625 342 448.536V472.536H385C399.912 472.536 412 484.625 412 499.536V529.536H0V499.536C0 484.625 12.0883 472.536 27 472.536H69V448.536ZM96 436.536H315C321.627 436.536 327 441.909 327 448.536V462.536H84V448.536C84 441.909 89.3726 436.536 96 436.536Z"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M110.732 275.772C89.3407 254.8 89.0013 220.458 109.973 199.067C130.946 177.677 165.288 177.337 186.678 198.309L195.789 207.241L299.064 101.905L289.953 92.9728C268.562 72.0007 268.223 37.6587 289.195 16.2678C310.167 -5.12299 344.509 -5.46242 365.9 15.5097L484.397 131.687C505.788 152.659 506.127 187.001 485.155 208.392C468.033 225.856 442 229.288 421.378 218.548L401.538 238.785L562.558 396.654C580.108 413.859 580.386 442.034 563.18 459.583C545.975 477.132 517.8 477.411 500.251 460.205L339.23 302.336L314.827 327.227C325.972 347.632 323.055 373.728 305.933 391.192C284.961 412.583 250.619 412.922 229.228 391.95L110.732 275.772ZM303.612 312.954L402.686 211.902L307.716 118.791L208.642 219.843L303.612 312.954ZM512.852 447.352L351.832 289.483L388.936 251.638L549.957 409.507C560.407 419.753 560.573 436.531 550.327 446.982C540.081 457.432 523.303 457.598 512.852 447.352Z"
            />
          </svg>
        )}
      />

      <Offcanvas style={{ width: "28rem", paddingTop: "0.75rem" }} show={isOpen} onHide={toggle} backdropClassName="opacity-0" placement="end">
        <Offcanvas.Header>
          <Offcanvas.Title className="d-flex justify-content-between align-items-center w-100 px-2">
            <div className="fw-600 fs-4">Online Case Status</div>
            <button onClick={toggle} type="button" className="bg-white border-0">
              <IoCloseCircle fill="#999999" size={30} />
            </button>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          {isLoading ? (
            <div className="position-relative top-50">
              <ContentLoader />
            </div>
          ) : analysis?.online_response_filled ? (
            <div className="pt-1">
              {!!analysis?.online_response_filled && (
                <div className="px-3 d-flex flex-column gap-3 m-3 fs-6">
                  <div className="d-flex justify-content-between gap-3">
                    <p className="mb-0 text-secondary fw-medium">Status</p>
                    <p className="mb-0 fw-medium">
                      {analysis?.online_response_filled?.submission_date ? (
                        <span style={{ color: "darkgreen" }} className="fw-600">
                          Filled Completely
                        </span>
                      ) : (
                        <span className="text-danger fw-600">Incomplete</span>
                      )}
                    </p>
                  </div>
                  <div className="d-flex justify-content-between gap-3 fs-6">
                    <p className="mb-0 text-secondary fw-medium">Disposition</p>
                    <p className="mb-0 fw-bold">{getDisposition(analysis?.online_response_filled?.intention)}</p>
                  </div>
                </div>
              )}

              <div style={{ background: "#F5F6F8" }} className="p-3 rounded d-flex flex-column gap-3 m-3 fs-6 py-6 ">
                {renderDispositionDetails(
                  getDisposition(analysis?.online_response_filled?.intention),
                  analysis?.online_response_filled
                ).map(({ label, value }, index) => (
                  <Fragment key={index}>
                    {!!value && (
                      <div className="d-flex justify-content-between gap-3 fs-6">
                        <p className="mb-0 text-secondary fw-medium">{label}</p>
                        <p className="mb-0 fw-600 text-black">{value}</p>
                      </div>
                    )}
                  </Fragment>
                ))}
              </div>
            </div>
          ) : (
            <p className="text-center py-5">No data Found</p>
          )}
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

